var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _radialGradient, _path4, _radialGradient2, _path5, _linearGradient4, _path6, _path7, _linearGradient5, _linearGradient6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeclassbc0C0563(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8a",
    x1: 31.917,
    x2: 33.251,
    y1: 19,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v0H_WcyaVQEjluOJ8Z2i8a)",
    d: "M31.916,17h-0.527v4h0.703c0.515,0,0.954-0.312,1.041-0.74l0.344-1.703 C33.642,17.743,32.897,17,31.916,17z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8b",
    x1: 63.917,
    x2: 65.251,
    y1: 19,
    y2: 19,
    gradientTransform: "matrix(-1 0 0 1 80 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c48f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#d19b16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#dca51f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0a922"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v0H_WcyaVQEjluOJ8Z2i8b)",
    d: "M16.084,17h0.527v4h-0.703c-0.515,0-0.954-0.312-1.041-0.74l-0.344-1.703 C14.358,17.743,15.103,17,16.084,17z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8c",
    x1: 24,
    x2: 24,
    y1: 23.241,
    y2: 10.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#ffdb80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.141,
    stopColor: "#fed97c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449,
    stopColor: "#f4bf3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#f0b421"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v0H_WcyaVQEjluOJ8Z2i8c)",
    d: "M24,6.133c-3.948,0-8,0.6-8,9.133c0,0.683,0,5.224,0,5.954c0,3.046,4.8,6.78,8,6.78 s8-3.733,8-6.78c0-0.73,0-5.271,0-5.954C32,6.733,27.948,6.133,24,6.133z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8d",
    cx: -30.38,
    cy: 12.062,
    r: 27.044,
    gradientTransform: "translate(43.086 -4.971) scale(.8816)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v0H_WcyaVQEjluOJ8Z2i8d)",
    d: "M24,4.545c-4.354,0-5,1.636-5,1.636C17.23,6.443,15,9.036,15,12c0,1.654,0.265,2.876,1,7 c0.545-6.545,1.249-9,3-9c1.267,0,2.273,1,5,1c2.303,0,2.875-1,5-1c3,0,3,7.968,3,9c0.601-3.01,1-5.555,1-7 C33,8.57,30.209,4.545,24,4.545z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8e",
    cx: -41.316,
    cy: 13.998,
    r: 33.398,
    gradientTransform: "matrix(.8431 0 0 .8816 57.401 -4.971)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v0H_WcyaVQEjluOJ8Z2i8e)",
    d: "M24.219,4c-4.164,0-5.216,2.182-5.216,2.182c-0.042,1.159,0.522,2.182,0.522,2.182 S20.285,10,24.625,10C27.245,10,31,8.365,31,4C31,4,30.157,4,24.219,4z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8f",
    x1: 23.452,
    x2: 26.261,
    y1: 21.287,
    y2: 44.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8795a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d7882"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v0H_WcyaVQEjluOJ8Z2i8f)",
    d: "M40,21H8c-1.173,0-2.094,1.005-1.992,2.173l1.652,19C7.75,43.207,8.615,44,9.652,44h28.695 c1.037,0,1.903-0.793,1.992-1.827l1.652-19C42.094,22.005,41.173,21,40,21z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#a3b3c2",
    d: "M26.476,36h-4.953c-0.129,0-0.236-0.099-0.246-0.227l-0.282-3.506C20.984,32.123,21.098,32,21.242,32 h5.516c0.144,0,0.258,0.123,0.246,0.267l-0.282,3.506C26.712,35.901,26.605,36,26.476,36z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8g",
    x1: 62.038,
    x2: 62.038,
    y1: 50.866,
    y2: 62.907,
    gradientTransform: "rotate(45.001 108 7.999)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd000"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "v0H_WcyaVQEjluOJ8Z2i8h",
    x1: 124.585,
    x2: 124.585,
    y1: -9.59,
    y2: 0.945,
    gradientTransform: "scale(-1 1) rotate(45 40 -156.168)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fede00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeclassbc0C0563);
export default __webpack_public_path__ + "static/media/code class.bc0c0563.16f581c54dafaf1e3dff85dd0433f92e.svg";
export { ForwardRef as ReactComponent };